var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stock-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticStyle: { width: "100%" },
          attrs: { data: _vm.stockTableData, border: "" },
          on: { "selection-change": _vm.selectOrder }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", fixed: "left" }
          }),
          _vm._v(" "),
          _vm.showindex
            ? _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "50" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "self_code", label: "商品编码", width: "105" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ruigu_code", width: "90", label: "锐锢商城编码" }
          }),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "name", width: "330", label: "商品名称" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "spec", width: "210", label: "工厂型号" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "c_name", width: "100", label: "分类" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "b_name", label: "品牌" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "stock_num",
              width: "100",
              label: _vm.isDeposit ? "当前可用库存" : "库存数量"
            }
          }),
          _vm._v(" "),
          _vm.isDeposit
            ? _c("el-table-column", {
                attrs: {
                  prop: "deposit_count",
                  label: "定金购占用库存",
                  width: "120"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "price", width: "100", label: "供货成交价" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "new_price", width: "100", label: "待审核价格" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "audit_status",
              label: "价格审核状态",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticStyle: { "text-align": "left" } }, [
                      _c("span", {
                        class: _vm.auditStatus(scope.row.audit_status).class
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-align": "center",
                            display: "inline-block"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.auditStatus(scope.row.audit_status).name)
                          )
                        ]
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "商品状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(scope.row.is_enable === "1" ? "启用" : "停用") +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.templateshow
            ? _c("el-table-column", {
                attrs: { prop: "is_sale", label: "是否在售" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "storage_pos", label: "库位" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "最新同步状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.sync_time
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                scope.row.sync_status == "1" ? "成功" : "失败"
                              ) +
                              "\n        "
                          )
                        ])
                      : _c("div")
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "最新同步时间", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(scope.row.sync_time) + "\n      "
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _vm.showindex
            ? _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "60" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _vm.shopStatus === 1 || _vm.shopStatus === -1
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#236bdc" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.editGoods(scope.row)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "店铺已停用，若需维护，请先启用店铺",
                                placement: "bottom",
                                effect: "light"
                              }
                            },
                            [
                              _vm.shopStatus === -2
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#236bdc" },
                                      attrs: { type: "text" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#999" } },
                                        [_vm._v("修改")]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  4244575755
                )
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showStockDialog
        ? _c("stock-dialog", {
            ref: "stockDialog",
            attrs: { rowData: _vm.rowData },
            on: { updateTable: _vm.updateTable }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c88bc04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c88bc04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/stock-table.vue
// module id = null
// module chunks = 